"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _progressStep = _interopRequireDefault(require("./progress-step"));

var _index = _interopRequireDefault(require("./index.scss"));

var ProgressTracker = function ProgressTracker(_ref) {
  var className = _ref.className,
      currentStepIndex = _ref.currentStepIndex,
      steps = _ref.steps,
      element = _ref.element;
  return _react["default"].createElement("nav", {
    "aria-label": "Progress Tracker"
  }, _react["default"].createElement("ol", {
    className: (0, _classnames["default"])(className, _index["default"].ProgressTracker)
  }, steps.map(function (step, index) {
    return _react["default"].createElement("li", {
      key: "progress-step-".concat(index)
    }, _react["default"].createElement(_progressStep["default"], (0, _extends2["default"])({
      isCurrent: currentStepIndex === index,
      label: step.label,
      disabled: step.disabled,
      element: element
    }, step)));
  })));
};

var _default = ProgressTracker;
exports["default"] = _default;